import { CalendlyExpert } from "@/features/experts/types/CalendlyExpert";

/**
 * Function to get a random expert from a list.
 * @param experts - List of available experts.
 * @returns A randomly selected expert.
 */
export const getRandomExpert = (experts: CalendlyExpert[]) => {
    if (experts.length === 0) {
        throw new Error("No eligible experts found.");
    }

    const index = Math.floor(Math.random() * experts.length);
    return experts[index];
};